/* eslint-disable */
import { FlagIconCode } from "react-flag-kit";

export const Languages: ILanguage[] = [
  {
    code: "fr-FR",
    flagCode: "FR",
    name: "FRENCH",
    value: "fr",
  },
  {
    code: "en-GB",
    flagCode: "GB",
    name: "ENGLISH",
    value: "en",
  },
  {
    code: "it-IT",
    flagCode: "IT",
    name: "ITALIAN",
    value: "it",
  },
  {
    code: "es-ES",
    flagCode: "ES",
    name: "SPANISH",
    value: "es",
  },
];

export interface ILanguage {
  flagCode: FlagIconCode;
  code: string;
  name: string;
  value: string;
}

export const EnumLanguages = {
  FRENCH: "FRENCH",
  ENGLISH: "ENGLISH",
  ITALIAN: "ITALIAN",
  SPANISH: "SPANISH",
};
